module.exports = __webpack_public_path__ + "static/media/Lens-Fresh_Lilac_HK.ba547365.png";